export enum ServerStatusType {
    OFFLINE = 'OFFLINE',
    RESTRICTED = 'RESTRICTED'
}

export default ServerStatusType;
